const METHOD_WARN = 'warn';
const METHOD_ERROR = 'error';
const METHOD_INFO = 'info';

function log(method = METHOD_ERROR, ...logArguments) {
  if (typeof console !== 'object' || typeof console[method] !== 'function') { // eslint-disable-line no-console
    return;
  }

  console[method](...logArguments); // eslint-disable-line no-console
}

export function logError(...logArguments: any) {
  log(METHOD_ERROR, ...logArguments);
}

export function logWarning(...logArguments: any) {
  log(METHOD_WARN, ...logArguments);
}

export function logInfo(...logArguments: any): void {
  if (window.app.env.NODE_ENV === 'production') {
    // don't log in production
    return;
  }

  log(METHOD_INFO, '➔', ...logArguments);
}
